<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="bulk-update-new-product"
        title="Bulk update new product"
        :active="visible"
        button-close-hidden
    >
      <vue-element-loading v-if="modalLoading" :active="modalLoading"></vue-element-loading>

      <vue-form-generator
          ref="form"
          :model="model"
          :schema="schema"
      />

      <div class="vx-col w-full text-right my-3">
        <vs-button
            class="mr-4 mt-2"
            @click="downloadTemplate"
            color="light"
            :disabled="downloadDisabled"
        >
          Download Template
        </vs-button>
        <vs-button class="ml-3" @click="cancel">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import Vue from 'vue';

const selectOptions = {
  showLabels: false,
  hideSelected: true,
  key: "id",
  trackBy: "id",
  label: "name",
};

export default {
  props: {
    visible: {
      // using visible instead of value (v-model) because of a conflict with FormModelMixin
      type: Boolean,
      default: false
    },
  },
  mixins: [FormModelMixin, NotificationMixin],
  data () {
    return {
      modalLoading: false,
      model: {
        Product_PK: {},
        Second_Product_PK: {},
      },
      schema: {
        groups: [
          {
            styleClasses: "vx-row w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "vx-col w-full",
                label: "New Product",
                model: "Product_PK",
                values: () => this.productOptions.map(( product ) => {
                  return {
                    id: product.id,
                    name: `${product.ProductCode} - ${product.ProductDescription}`,
                  }
                }),
                selectOptions,
              },
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "vx-col w-full",
                label: "Existing Product",
                model: "Second_Product_PK",
                values: () => this.productOptions.map(( product ) => {
                  return {
                    id: product.id,
                    name: `${product.ProductCode} - ${product.ProductDescription}`,
                  }
                }),
                selectOptions,
              },
            ]
          },
        ],
      },
      productOptions: [],
      options: [
        {
          endpoint: () => this.$api.products.list(),
          optionsFieldName: "productOptions",
          nameFieldName: "ProductDescription",
          idFieldName: 'id',
          additionalFields: [
            "ProductCode",
            "ProductDescription",
          ],
        },
      ],
    }
  },
  computed: {
    downloadDisabled() {
      return !(this.model.Product_PK
          && this.model.Product_PK.id
          && this.model.Second_Product_PK
          && this.model.Second_Product_PK.id)
    }
  },
  methods: {
    async getTemplate()  {
      try {
        const { data } = await this.$api.clientMap.downloadBulkUpdateProductTemplate(this.model.Product_PK.id, this.model.Second_Product_PK.id)

        const blob = new Blob([data], { type: this.getFileType('csv') })
        const filename = 'ProductTemplate.csv';

        const link = document.createElement('a')

        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()

        URL.revokeObjectURL(link.href)
      } catch (e) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    getFileType(extension) {
      let fileType;
      switch (extension) {

        default:
          fileType = 'application/' + extension;
          break;
      }

      return fileType;
    },
    cancel() {
      this.$emit('cancel');
    },
    async downloadTemplate() {
      this.modalLoading = true;

      if (!this.model.Product_PK || !this.model.Product_PK.id) {
        this.notifyWarning('Please select a product');

        this.modalLoading = false;
        return false;
      }

      if (!this.model.Second_Product_PK || !this.model.Second_Product_PK.id) {
        this.notifyWarning('Please select a second product');

        this.modalLoading = false;
        return false;
      }

      try {
        await this.getTemplate();
        this.$emit('updated');
      } catch (e) {
        this.$emit('error', 'Error occurred. Please try again later');
        console.error(e)
      } finally {
        this.modalLoading = false;
      }
    }
  },
}

</script>

<style lang="scss">
.vs-popup--content {
  overflow: visible;
}
</style>
